import { render, staticRenderFns } from "./back.vue?vue&type=template&id=2af03e07"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"
import style0 from "./back.vue?vue&type=style&index=0&id=2af03e07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports